export const iconFontAwesomeBuildingsDungeon = (
	<i className="fa-solid fa-dungeon"></i>
);
